import { render } from "./cell_money2.vue?vue&type=template&id=5e837ad8"
import script from "./cell_money2.vue?vue&type=script&lang=ts"
export * from "./cell_money2.vue?vue&type=script&lang=ts"
script.render = render

export default script